export const environment = {
  production: true,
  API_URL: "https://memicapimanagenment.azure-api.net/safetydirector/",
  // List of trusted domains that should NOT trigger external link warning
  KNOWN_SITES: [
    'https://memic.sharepoint.com',
    'https://www.memic.com',
    'https://memic.com'
  ],
  subKey: 'subKey',
      //•	Microsoft official documentation states:
    //The instrumentation key is not a secret. It is designed to be included in client-side code.
    appInsights: {
      instrumentationKey: 'appInsightsKey'
    }
};

export const b2cPolicies = {
  clientId: '1a63ba18-f63e-4cbe-ac56-add368723432', //PROD
  names: {
    signUpSignIn: "B2C_1A_SIGNUP_SIGNIN",
    editProfile: "B2C_1_PROFILEEDIT"
  },
  authorities: {
    signUpSignIn: {
      authority: "https://memicextauth.b2clogin.com/memicExtAuth.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN",
    },
    editProfile: {
      authority: "https://memicextauth.b2clogin.com/memicExtAuth.onmicrosoft.com/B2C_1_PROFILEEDIT"
    }
  },
  authorityDomain: "memicExtAuth.b2clogin.com",
  redirectUri: '/',
  postLogoutRedirectUri: '/'
};
export const EventName = {
  dementiaSeriesDownloadFile: "dementia-series-download-file",
  dementiaSeriesOpenModal: "dementia-series-open-modal",
  webinarOnDemandDownloadFile: "webinar-on-demand-download-file",
  webinarOnDemandUpdateIndustry: "webinar-on-demand-update-industry",
  webinarOnDemandOpenModal: "webinar-on-demand-open-modal",
  webinarOnDemandClearRefiner: "webinar-on-demand-clear-refiner",
  webinarOnDemandFeaturedTopicFilter: "webinar-on-demand-featured-topic-filter",
  webinarOnDemandSecondaryFeaturedTopicFilter: "webinar-on-demand-secondary-featured-topic-filter",
  memicMinutesDownloadFile: "memic-minutes-download-file",
  memicMinutesUpdateIndustry: "memic-minutes-update-industry",
  memicMinutesFeaturedTopicFilter: "memic-minutes-featured-topic-filter",
  memicMinutesSecondaryFeaturedTopicFilter: "memic-minutes-secondary-featured-topic-filter",
  memicMinutesOnClearRefiner: "memic-minutes-onclear-refiner",
  mostPopularDownloadFile: "most-popular-download-file",
  industryResourcesLatestResource : "industry-resources-latest-resource",
  industryResourcesTrainingEvent : "industry-resources-training-event",
  industryResourcesWebinarOnDemandLink : "industry-resources-webinar-on-demand-link", 
  resourceLibraryDownloadFile: "resource-library-download-file",
  resourceLibraryDocumentTypeFilter: "resource-library-document-type-filter",
  resourceLibraryFeaturedTopicFilter: "resource-library-featured-topic-filter",
  resourceLibrarySecondaryFeaturedTopicFilter: "resource-library-secondary-featured-topic-filter",
  resourceLibraryIndustryChange: 'resource-library-industry-change',
  resourceLibraryFavourite: 'resource-library-Favourite',
  homePageTileNavigation: 'homepage-tile-navigation',
  resourcesLibraryAddFavorite: 'resources-library-add-favorite',
  resourcesLibraryRemoveFavorite: 'resources-library-remove-favorite',
  favoriteResourcesAdd: 'favorite-resources-add',
  favoriteResourcesRemove: 'favorite-resources-remove',
  favoriteResourcesDownloadFile: 'favorite-resources-download-file',
  homeCarouselImageClicked: 'home-carousel-image-clicked',
}
